import PropTypes from "prop-types";
import { Tag, Timeline } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import { buildLifecycleSteps, formatReservationDate, formatReservationTime } from "../utils";

const LifecycleTimeline = ({ resDetails, t }) => {
    const steps = buildLifecycleSteps(resDetails, t);

    return (
        <div className="rounded-2xl border border-[#f0f0f0] bg-white p-4 lg:p-5">
            <div className="mb-4 flex items-center gap-2">
                <ClockCircleOutlined className="text-[#5D5DF6]" />
                <h2 className="fontSemi text-base text-[#2F2F46]">{t("upcomingDetails.lifecycleTitle")}</h2>
            </div>

            <Timeline
                items={steps.map((step) => ({
                    color: step.completed ? "#5D5DF6" : "gray",
                    children: (
                        <div className="flex flex-col gap-1 pb-1">
                            <div className="flex flex-wrap items-center gap-2">
                                <span className="fontSemi text-sm text-[#2F2F46]">{step.title}</span>
                                {!step.completed ? (
                                    <Tag className="!m-0 !rounded-full !border-none !bg-[#F2F2FA] !px-2 !text-[11px] !text-[#9b9ba5]">
                                        {t("upcomingDetails.pending")}
                                    </Tag>
                                ) : null}
                            </div>
                            {step.completed && step.timestamp ? (
                                <span className="fontRegular text-xs text-[#9b9ba5]">
                                    {formatReservationDate(step.timestamp, "MMM D, YYYY")} ·{" "}
                                    {formatReservationTime(step.timestamp)}
                                </span>
                            ) : null}
                        </div>
                    ),
                }))}
            />
        </div>
    );
};

LifecycleTimeline.propTypes = {
    resDetails: PropTypes.object,
    t: PropTypes.func.isRequired,
};

export default LifecycleTimeline;
